import Vue from 'vue';
import VueSplit from 'vue-split-panel';

Vue.use(VueSplit);
